import { render } from "./Viewed.vue?vue&type=template&id=3a3f633e&scoped=true"
import script from "./Viewed.vue?vue&type=script&lang=js"
export * from "./Viewed.vue?vue&type=script&lang=js"

import "./Viewed.vue?vue&type=style&index=0&id=3a3f633e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3f633e"]])

export default __exports__